/**
 * Session-scoped memory of the report-handoff choice the user made on a given
 * assistant message (which portfolio they picked from the disambiguation card).
 *
 * ReportHandoff keeps the selection in local component state, which is lost when
 * you switch chats and come back (the component re-mounts). Persisting it here,
 * keyed by the message's server id, lets the re-mounted card restore the
 * collapsed selection + open-report button instead of re-showing the choices.
 *
 * Module-level (survives component re-mounts and chat navigation within the
 * session); intentionally NOT localStorage — a full page reload re-fetches the
 * conversation fresh, and these are cheap to re-pick.
 */
const selections = new Map();

export function getHandoffSelection(messageId) {
  return messageId != null ? selections.get(messageId) || null : null;
}

export function setHandoffSelection(messageId, choice) {
  if (messageId != null) selections.set(messageId, choice);
}

/** Drop everything — used when the user deletes all chat history. */
export function clearAllHandoffSelections() {
  selections.clear();
}
